import React from 'react';
import { 
  Target, 
  Users, 
  Award, 
  TrendingUp,
  CheckCircle,
  ArrowRight
} from 'lucide-react';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <Target className="value-icon" />,
      title: "Precision & Excellence",
      description: "We deliver solutions with meticulous attention to detail and unwavering commitment to quality."
    },
    {
      icon: <Users className="value-icon" />,
      title: "Client-Centric Approach",
      description: "Your success is our priority. We work closely with you to understand and exceed your expectations."
    },
    {
      icon: <TrendingUp className="value-icon" />,
      title: "Innovation & Growth",
      description: "We stay ahead of technology trends to provide cutting-edge solutions that drive your business forward."
    },
    {
      icon: <Award className="value-icon" />,
      title: "Proven Results",
      description: "Our track record speaks for itself with successful projects and satisfied clients across various industries."
    }
  ];

  const achievements = [
    { number: "3+", label: "Years of Experience" },
    { number: "100+", label: "Projects Delivered" },
    { number: "50+", label: "Happy Clients" },
    { number: "99%", label: "Success Rate" }
  ];

  const expertise = [
    "Multi-Platform API Integration",
    "Business Process Automation",
    "Custom Web Development",
    "Database Management",
    "Workflow Optimization",
    "System Integration",
    "Data Analytics",
    "Cloud Solutions"
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <div className="section-header">
              <h2>About OnSkip</h2>
              <p className="section-subtitle">
                Transforming businesses through intelligent automation and innovative web solutions
              </p>
            </div>

            <div className="about-description">
              <p>
              OnSkip is a specialized technology consulting firm dedicated to streamlining business 
              operations through multi-platform automation and custom development solutions. We bridge the gap 
              between complex business needs and innovative technology solutions.
              </p>
              <p>
                Our expertise in business process automation, data management, and custom web development 
                has helped numerous businesses reduce manual work, increase efficiency, and achieve 
                measurable growth. We don't just build solutions – we create transformative experiences 
                that empower your team to focus on what matters most.
              </p>
            </div>

            <div className="expertise-list">
              <h3>Our Core Expertise</h3>
              <div className="expertise-grid">
                {expertise.map((skill, index) => (
                  <div key={index} className="expertise-item">
                    <CheckCircle size={16} className="check-icon" />
                    <span>{skill}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-cta">
              <a 
                href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Work With Us <ArrowRight size={18} />
              </a>
            </div>
          </div>

          <div className="about-visual">
            <div className="achievements-card">
              <h3>Our Impact</h3>
              <div className="achievements-grid">
                {achievements.map((achievement, index) => (
                  <div key={index} className="achievement-item">
                    <div className="achievement-number">{achievement.number}</div>
                    <div className="achievement-label">{achievement.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="values-section">
          <h3>Why Choose OnSkip</h3>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon-container">
                  {value.icon}
                </div>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
